<script>
	import { onMount } from 'svelte';

	let loader;
	let Component;

	onMount(async () => {
		await new Promise((f) => setTimeout(f, 250)); // simulate delay
		Component = (await loader()).default;
	});

	export { loader as this };
</script>

<svelte:component this={Component} {...$$restProps}>
	<slot />
</svelte:component>

{#if !Component}
	<div class="loader-fallback bg-cosmicPurple800 min-h-screen">
		<slot name="fallback" />
	</div>
{/if}

<style>
	.loader-fallback {
		background-color: #1b0d2a; /* Your dark purple background */
		min-height: 100vh; /* Ensures full page coverage */
	}
</style>
